<template>
  <div v-if="courseTag" class="course-tag-page">
    <div class="tag-box">
      <div ref="courseTag" class="course-tag">
        <div :class="['course-tag-item',item.id === currentId ? 'active' : '']" v-for="item in topList" :key="item.id" @click="tagClick(item)">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div @click="showMoreItem" class="more" v-if="list.length > 8">
      <span>查看更多</span>
      <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/combinationCourse/courseTagMore.png" />
    </div>
    <van-popup v-model="show" position="bottom">
      <div class="courseTagList">
        <h2 class="tag-list-box">请选择需要了解的课程</h2>
        <img @click="close" class="tag-close" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/combinationCourse/courseModalCloase.png" />
        <div ref="courseTag" class="course-tag modal">
          <div :class="['course-tag-item',item.id === currentId ? 'active' : '']" v-for="item in list" :key="item.id" @click="tagClick(item,'hide')">
          <span>
            {{ item.name }}
          </span>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      show: false,
      list: [],
      topList: [],
      showMore: false,
      currentId: 99,
      courseTag: false,
      allTagListData: [],
    };
  },
  computed: {
    ...mapState(['courseBaseData']),
  },
  watch: {
    courseBaseData() {
      const { packageProductRespList, packageGroupWebRespList, tag } = this.courseBaseData;
      if (tag) {
        let allGroupProduct = [];
        this.courseTag = true;
        packageGroupWebRespList?.forEach((item) => { allGroupProduct = allGroupProduct.concat(item?.packageProductWebRespList || []); });
        this.allTagListData = packageProductRespList?.concat(allGroupProduct)
        this.list = packageProductRespList?.map((item) => ({ id: item.productId, name: item?.tag })).concat(allGroupProduct?.map((item) => ({ id: item.productId, name: item?.tag })));
        this.list = this.list.filter((item) => item.name);
        this.list.unshift({ id: 99, name: '定制套餐' });
        this.topList = this.list.slice(0, 11);
      }
    },
  },
  mounted() {},
  methods: {
    showMoreItem() {
      this.show = true;
    },
    tagClick(data, hide) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 300,
      });
      this.currentId = data.id;
      this.$store.dispatch('savCourseData', { ...this.courseBaseData, allTagListData: this.allTagListData, currentIntroductionId: data.id, introductionType:data.id === 99 ? 1 : 2 });
      if (hide && hide === 'hide') {
        this.close();
      }
    },
    close() {
      this.show = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.course-tag-page{
  padding-bottom: 20px;
  background: #fff;
}
.course-tag {
  display: grid;
  grid-template-columns: repeat(auto-fill, 24%);
  gap: 11px 8px;
  box-sizing: border-box;
  width: 100%;
  padding: 0 36px;
  background: #fff;

  &::after {
    flex: auto;
    content: "";
  }
}
.course-tag.modal {
  gap: 29px 8px;
}

.tag-box {
  width: 100%;
  max-height: 120px;
  overflow: hidden;
}

.course-tag-item {
  width: 163px;
  height: 54px;
  overflow: hidden;
  color: #666;
  font-size: 22px;
  line-height: 52px;
  text-align: center;
  border: 1px solid #E8E8E8;
  border-radius: 26px;
}
.course-tag-item.active{
  color: #FF6C02;
  background: #FFF5ED;
  border: 1px solid #FF6C02;
}
.more{
  width: 100%;
  margin-top: 29px;
  color: #666;
  font-size: 22px;
  text-align: center;
}
.more span{
  vertical-align: middle;
}
.more img{
  width: 29px;
  height: 29px;
  margin-top: 2px;
  vertical-align: middle;
}
.tag-list-box{
  width: 100%;
  margin-top: 29px;
  margin-bottom: 65px;
  color: #333;
  font-weight: 600;
  font-size: 33px;
  line-height: 45px;
  text-align: center;
}
.courseTagList{
  position: relative;
  width: 100%;
  height: 578px;
}
.tag-close{
  position: absolute;
  top: 36px;
  right: 36px;
  width: 30px;
  height: 30px;
}
</style>
